import { css } from '@emotion/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BillboardButton, LayoutBand, H1, Paragraph, WhiteTheme, Separator, useContainerWidth } from '@fs/zion-ui'
import heroImage from '../assets/FamilyInterviewQuestions.webp'
import FamilyInterviewQuestionsPDF from '../assets/FamilyInterviewQuestions.pdf'

const heroStyle = css`
  position: relative;
  background-size: cover;
  background-position: center;

  &::before {
    content: '';
    display: block;
    inset: 0;
    position: absolute;
    /* Dark overlay using linear-gradient */
    background: var(--background-gradient, rgba(0, 3, 7, 0.67));
  }
`
export default function FamilyInterviewQuestionsHero() {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()
  const TextWrapper = atWidth({ default: 'div', lg: WhiteTheme })

  return (
    <>
      <LayoutBand
        alignY="middle"
        marginY={atWidth({ default: 'lg', lg: 'md' })}
        minHeight={atWidth({ lg: 600 })}
        marginX={atWidth({ default: 'sm', lg: 'xxl' })}
        maxWidth="xl"
        image={atWidth({ default: null, lg: heroImage })}
        css={atWidth({ default: null, lg: heroStyle })}
        style={{
          '--background-gradient': atWidth({
            default: null,
            lg: 'linear-gradient(90deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 80%)',
          }),
        }}
      >
        <TextWrapper style={atWidth({ default: null, lg: { maxInlineSize: 800, zIndex: 1 } })}>
          <H1 balanced>{t('tree-overview.family-interview.hero.heading', 'Family Interview Questions')}</H1>

          <Separator size="sm" />

          <Paragraph size={atWidth({ default: 'sm', lg: 'md' })}>
            {t(
              'tree-overview.family-interview.hero.description',
              'A guide to help you gather family history information and preserve precious stories.'
            )}
          </Paragraph>

          <Separator size="md" />

          <BillboardButton
            color="gray"
            download={t('tree-overview.family-interview.download-pdf-filename.label', 'Family-Interview-Questions.pdf')}
            emphasis={atWidth({ default: 'high', lg: 'lightHigh' })}
            linkName="familyInterviewQuestionsHeroDownloadPdf"
            to={FamilyInterviewQuestionsPDF}
          >
            {t('tree-overview.family-interview.hero.download-button', 'Download PDF')}
          </BillboardButton>
        </TextWrapper>
      </LayoutBand>
      {atWidth({ default: true, lg: false }) && <LayoutBand image={heroImage} marginY="none" minHeight={275} />}
    </>
  )
}
